import {
  ArrowsClockwiseIcon,
  BlueprintIcon,
  BuildingOfficeIcon,
  ClipboardTextIcon,
  DatabaseIcon,
  FolderSimpleIcon,
  GlobeIcon,
  type Icon,
  IdentificationCardIcon,
  ListChecksIcon,
  LockIcon,
  MedalIcon,
  NotePencilIcon,
  ShieldCheckIcon,
  ShieldIcon,
  TreeStructureIcon,
  UsersIcon,
  WarningIcon,
} from '@phosphor-icons/react';

/**
 * Unique icon per Organization Profile category, keyed by the stable
 * prerequisite-intake category keys (the fixed 8-category taxonomy). Each key
 * maps to a distinct glyph so users can tell the categories apart at a glance.
 */
const KEY_ICONS: Record<string, Icon> = {
  dpo_appointment: IdentificationCardIcon,
  dpo_roles: ListChecksIcon,
  cyber_dm_it: ShieldCheckIcon,
  enterprise_arch: BlueprintIcon,
  business_forms: NotePencilIcon,
  privacy_champions: MedalIcon,
  org_structure: TreeStructureIcon,
  sops: ClipboardTextIcon,
};

/**
 * Icon for a category. Prefers an exact match on the canonical category key so
 * each standard category has its own glyph; falls back to keyword matching on
 * the key/name for any non-standard (custom template) category.
 */
export function categoryIcon(key: string, name: string): Icon {
  const exact = KEY_ICONS[key];
  if (exact) return exact;

  const h = `${key} ${name}`.toLowerCase();
  if (/privacy/.test(h)) return ShieldIcon;
  if (/secur|infosec|cyber/.test(h)) return LockIcon;
  if (/hr|human|people|personnel|employ/.test(h)) return UsersIcon;
  if (/risk/.test(h)) return WarningIcon;
  if (/vendor|supplier|third.?party|procure/.test(h)) return GlobeIcon;
  if (/architect|enterprise|infrastructure|tech/.test(h)) return DatabaseIcon;
  if (/continuit|resilien|recovery|bcp/.test(h)) return ArrowsClockwiseIcon;
  if (/corporate|organi|company|entity/.test(h)) return BuildingOfficeIcon;
  return FolderSimpleIcon;
}
